export default __webpack_public_path__ + "static/media/ic_send_sp.96429720.svg";